import React from 'react'
import styled from 'styled-components'
import { buildImageObj } from '../../lib/helpers'
import { imageUrlFor } from '../../lib/image-url'

const StylesFigure = styled.figure`
  margin: 2rem 0;
  padding: 0;

  img {
    width: 100%;
    height: auto;
  }
`

function Figure(props) {
  return (
    <StylesFigure>
      {props.asset && (
        <img
          src={imageUrlFor(buildImageObj(props)).width(600).url()}
          alt={props.alt}
        />
      )}
    </StylesFigure>
  )
}

export default Figure
